/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { comptabilityControllerDownloadReportMakingOrdersByMonths } from '../fn/comptability/comptability-controller-download-report-making-orders-by-months';
import { ComptabilityControllerDownloadReportMakingOrdersByMonths$Params } from '../fn/comptability/comptability-controller-download-report-making-orders-by-months';

@Injectable({ providedIn: 'root' })
export class ComptabilityApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `comptabilityControllerDownloadReportMakingOrdersByMonths()` */
  static readonly ComptabilityControllerDownloadReportMakingOrdersByMonthsPath = '/api/comptability/download/report-making-orders-by-month';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `comptabilityControllerDownloadReportMakingOrdersByMonths()` instead.
   *
   * This method doesn't expect any request body.
   */
  comptabilityControllerDownloadReportMakingOrdersByMonths$Response(params: ComptabilityControllerDownloadReportMakingOrdersByMonths$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = comptabilityControllerDownloadReportMakingOrdersByMonths(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `comptabilityControllerDownloadReportMakingOrdersByMonths$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  comptabilityControllerDownloadReportMakingOrdersByMonths(params: ComptabilityControllerDownloadReportMakingOrdersByMonths$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.comptabilityControllerDownloadReportMakingOrdersByMonths$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
